<template>
    <EditCuponForm
        :cupom-id="cupomId"
        layout="page"
        @success="onSuccess"
        @cancel="goBack"
    />
</template>

<script>
    import EditCuponForm from '@/components/Weflix/Payment/EditCuponForm.vue';

    export default {
        components: {
            EditCuponForm,
        },
        computed: {
            cupomId() {
                return String(this.$route.params.slug || '');
            },
        },
        methods: {
            onSuccess() {
                /* Toast já é exibido pelo formulário */
            },
            goBack() {
                this.$router.push('/admin/pagamentos');
            },
        },
    };
</script>
